import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Select } from 'module-tsl-ui-elements';

const SortJobs = ({ includeDistanceSort, items, sort, onChanged, history: { push }, base }) =>
  <div>
    <Select
      id="sort-jobs"
      value={sort}
      className="tds-select tds-select--inline tds-select--auto"
      onChange={evt => onChanged(evt, push, base)}
      name="sort"
      options={items.filter(item => item.id !== 'distance' || includeDistanceSort).map(item => ({ value: item.id, label: item.label }))}
    />
  </div>;

SortJobs.propTypes = {
  items: PropTypes.array,
  includeDistanceSort: PropTypes.bool,
  sort: PropTypes.string,
  onChanged: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  base: PropTypes.shape({
    pathname: PropTypes.string,
    qs: PropTypes.string
  }).isRequired
};

SortJobs.defaultProps = {
  sort: 'date',
  items: [],
  includeDistanceSort: false
};

export const SortJobsSelect = withRouter(SortJobs);
